<template>
  <div id="app" :class="{vueAppClasses, mobile}">
    <div ref="result"></div>
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'


export default {

  data () {
    return {
      vueAppClasses: [],
      mobile:window.innerWidth <= 700,
      showSearch: false,
      addressDefaults: {
        id: 0,
        user_id:0,
        name: '',
        full_name: '',
        email: '',
        phone: '',
        address: 'Create an address',
        coordinate: '',
        region: '',
        city: '',
        district: '',
        post_code: '',
        default: 0,
        is_active:1
      },
      userDefaults: {
        id          : 0,          // From Auth
        name        : 'Turkish Restaurant', // From Auth
        last_name   : '',
        full_name   : '',
        photoURL    : require('@/assets/images/logo/logo.png'), // From Auth
        photo       : require('@/assets/images/logo/logo.png'), // From Auth
        email       : 'info@turkishrestaurant.com',
        user_group  : 'admin',
        user_property: {}
      },
      placesService: null
    }
  },
  metaInfo: {
    title: 'Turkish Restaurant',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Order Online from the best turkish restaurants around town'
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: 'Turkish Mediterranean Cuisine'
      }
    ]
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    '$route' (to) {
      if (to.params.restaurant) {
        to.meta.pageTitle = to.params.restaurant.user_property['Restaurant-Name'] || 'Turkish Restaurant'
      }
    },
    isLoggedIn () {
      if (this.isLoggedIn) {
        const defAddress = this.$store.state.api.defaultAddress
        const userInfo = this.$store.state.api.currentUser
        const delAddress = this.$store.state.api.deliveryAddress

        const storageDefAddress = JSON.parse(localStorage.getItem('addressInfo'))
        const storageDelAddress = JSON.parse(localStorage.getItem('deliveryInfo'))
        const storageUser = JSON.parse(localStorage.getItem('userData'))
        if (defAddress.id === 0) {
          if (storageDefAddress) {
            this.$store.commit('api/SET_DEFAULT_ADDRESS', storageDefAddress)
          }
        }
        if (delAddress.id === 0) {
          if (storageDelAddress) {
            this.$store.commit('api/SET_DELIVERY_ADDRESS', storageDelAddress)
          }
        }
        if (userInfo.id === 0) {
          if (storageUser) {
            this.$store.commit('api/SET_USER', storageUser)
          }
        }
      } else {
        this.$store.commit('api/SET_DELIVERY_ADDRESS', this.addressDefaults)
        this.$store.commit('api/SET_DEFAULT_ADDRESS', this.addressDefaults)
        this.$store.commit('api/SET_USER', this.userDefaults)
      }
    }
  },
  computed: {
    cartItems () {
      return JSON.parse(localStorage.getItem('cartItems')) || this.$store.state.eCommerce.cartItems.slice().reverse()
    },
    defaultAddress () {
      return JSON.parse(localStorage.getItem('addressInfo')) || this.$store.state.api.defaultAddress
    },
    deliveryAddress () {
      return JSON.parse(localStorage.getItem('deliveryInfo')) || this.$store.state.api.deliveryAddress
    },
    isMobile () {
      return this.$store.state.api.isMobile
    },
    showFloatingCart () {
      return this.$store.state.api.showCart
    },
    isLoggedIn () {
      return this.$store.state.api.token_valid
    }
  },
  methods: {
    openAlertAddress (accept) {
      this.$vs.dialog({
        type:'alert',
        color: 'danger',
        title: 'Address Information',
        text: 'Oops! You don\'t seem to have an address. Please provide an address to proceed',
        accept
      })
    },
    handleLocalstorage () {
      const cart = this.$store.state.eCommerce.cartItems
      const restaurant = this.$store.state.api.restaurant

      const storageCart = JSON.parse(localStorage.getItem('cartItems'))
      const storageRestaurant = JSON.parse(localStorage.getItem('restaurant'))

      if (!restaurant) {
        if (storageRestaurant) {
          this.$store.commit('api/SET_RESTAURANT', storageRestaurant)
        }
      }
      if (cart.length === 0) {
        if (storageCart) {
          this.$store.commit('eCommerce/SET_CART', storageCart)
        }
      }
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    messageListener (event) {
      const origin = event.origin || event.originalEvent.origin // For Chrome, the origin property is in the event.originalEvent object.
      if (origin.includes('turkishrestaurant')) {
        return
      }

      if (typeof event.data === 'object' && event.data.call === 'sendValue') {
        // Do something with event.data.value;
      }
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
      this.mobile = innerWidth <= 700

      this.$store.commit('api/SET_MOBILE', this.mobile)
    },
    onScrollEvent () {
      const myScroll = document.querySelector('#app').getBoundingClientRect().top
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', myScroll)
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.onScrollEvent)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', false)
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    this.handleLocalstorage()

    this.$store.commit('api/SET_MOBILE', this.mobile)
    window.addEventListener('message', this.messageListener, false)

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.onScrollEvent)
    window.removeEventListener('message', this.messageListener)
  }
}

</script>
